import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../Redux/store";

const crmUrl = 'https://customer.hirsch.com/account/v1/employee/customer/crm';
const actionUrl = 'https://customer.hirsch.com/account/v2/employee/customer/crm/action'

type props = {
    custID: string;
    note: string
}

export const postCRM = createAsyncThunk<any, props, {state: RootState}>(
    'crm/postCRM',
    async ({ custID, note }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
    
            if (!token) throw new Error('No token Found');
    
            const res = await fetch(crmUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                },
                body: JSON.stringify({ id: custID, message: note })
            })
            const json = await res.json();

            if (!json.ack) {
                console.error('Post CRM Error:', json.errorMessage);
                return rejectWithValue(json.errorMessage);
            }
            
            console.log('Post CRM:', json);
            return json;
        } catch (e: any) {
            return rejectWithValue(e.message);
        }
    }
);

export const actionCRM = createAsyncThunk<any, props, {state: RootState}>(
    'crm/actionCRM',
    async ({ custID, note }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
    
            if (!token) throw new Error('No token Found');
    
            const res = await fetch(actionUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                },
                body: JSON.stringify({ id: custID, message: note })
            })
            const json = await res.json();

            if (!json.ack) {
                console.log('Action CRM Error:',json.errorMessage)
                return rejectWithValue(json.errorMessage);
            }
            
            console.log('Action CRM:', json);
            return json;
        } catch (e: any) {
            console.error(e.message)
            return rejectWithValue(e.message);
        }
    }
);

interface CRMState {
    loading: boolean;
    error: boolean | null;
    errMsg: string;
};

const initialState: CRMState = {
    loading: false,
    error: null,
    errMsg: '',
};

const crmSlice = createSlice({
    name: 'crm',
    initialState,
    reducers: {
        resetCRMStatus: (state) => {
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(postCRM.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.errMsg = '';
        })
        .addCase(postCRM.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.errMsg = '';
        })
        .addCase(postCRM.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errMsg = action.payload as string;
        })
        .addCase(actionCRM.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.errMsg = '';
        })
        .addCase(actionCRM.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.errMsg = '';
        })
        .addCase(actionCRM.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errMsg = action.payload as string;
        })
    }
});

export const { resetCRMStatus } = crmSlice.actions;
export const crmReducer = crmSlice.reducer;
